/* eslint-disable no-unused-vars */

import React, { useState, useEffect } from 'react';
import ImageGrid from './ImageGrid';
const API = process.env.REACT_APP_API_URL || "";

  function AllWork({excludedFolders, excludedImages}) {
    // const { folder } = useParams();

    useEffect(() => {
        document.title = "All Work";
      }, []);
  

    const [hasError, setHasError] = useState(false);
    const [allImages, setAllImages] = useState([]);
    const [imageCount, setImageCount] = useState(0);
    const [nextCursor, setNextCursor] = useState('');
    const [isLoading, setIsLoading] = useState(true);

    const imageUrl = `${API}/allimages`;

   useEffect(() => {
     
    const fetchAllImages = async () => {
    setIsLoading(true);

    try {
        const response = await fetch(imageUrl);

        if (!response.ok) {
        throw new Error(`Failed to fetch images`);
        }

        const data = await response.json();

        // console.log(
        //  "folders returned:",
        // [...new Set(data.images.map(i => i.asset_folder))]
        // );
        if (data.images) {

        const filterByImages = data.images.filter(
            item => !excludedImages.includes(item.asset_id)
        );

        const filterByFolders = filterByImages.filter(
            item => !excludedFolders.includes(item.asset_folder)
        );
        
        setAllImages(filterByFolders);
        setNextCursor(data.nextCursor || "");

        // FIXED LINE
        setImageCount(
            data.totalImages || data.total_count || filterByFolders.length
        );

        } else {
        setAllImages([]);
        setImageCount(0);
        }

    } catch (error) {
        console.error("Error fetching collection images:", error);
        setHasError(true);
    }

    setIsLoading(false);
    };

    fetchAllImages();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [imageUrl]);

   


    if (isLoading) {
        return <div className="body-container">Loading...</div>;
    }

    if (hasError) {
        return <div className="body-container">Error loading images.</div>;
    }

    if (allImages.length === 0) {
        return <div className="body-container">No images found.</div>;
    }

    return (
      <div>
          <div className="body-container">
            <h1>All Work</h1>
         </div>
          <div>
              
            <ImageGrid
            imageData={allImages}
            imageCount={imageCount}
            nextCursor={nextCursor}
            url={imageUrl}
            excludedFolders={excludedFolders}
            excludedImages={excludedImages}
            isAllWorkPage={true}
            />
          </div>
        </div>
    );
}
  
  export default AllWork;
  